/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import axios from 'axios'
import CurrencyFormat from 'react-currency-format'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const getLocalData = () => {
  const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  return JSON.parse(data)
}

const Statements = () => {
  const apiToken = getLocalData().api_token
  const [totalBalance, setTotalBalance] = useState({})
  const [totalPendding, setTotalPendding] = useState({})

  const API_URL = process.env.REACT_APP_API_URL
  const GET_TOTAL_BALANCE = `${API_URL}/user/balance`

  const getTotalBalance = async () => {
    const config = {
      headers: {Authorization: `Bearer ${apiToken}`},
    }
    await axios
      .get(GET_TOTAL_BALANCE, config)
      .then((response) => {
        setTotalBalance(response.data.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  useEffect(() => {
    getTotalBalance()
  }, [])

  return (
    <div className='m-5'>
      <div className='card shadow card-xxl-stretch mb-5'>
        <div className='card-header'>
          <div className='card-title'>
            <h3>Net Earnings</h3>
          </div>
        </div>
        <div className='card-body pb-0'>
          <span className='d-none fs-5 fw-semibold text-gray-600 pb-5 d-block'>
            Last 30 day earnings calculated. Apart from arranging the order of topics.
          </span>
          <div className='d-flex flex-wrap justify-content-between pb-6'>
            <div className='d-flex flex-wrap'>
              <div className='border border-dashed border-gray-300 w-200px rounded my-3 p-4 me-6'>
                <span className='fs-2x fw-bold text-gray-800 lh-1'>
                  <span
                    data-kt-countup='true'
                    data-kt-countup-value='6,840'
                    data-kt-countup-prefix='$'
                  >
                    {totalBalance.total_credit ? (
                      <CurrencyFormat
                        decimalScale={2}
                        value={parseFloat(totalBalance?.total_credit).toFixed(2)}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                      />
                    ) : (
                      '$0'
                    )}
                  </span>
                </span>
                <span className='fs-6 fw-semibold text-info d-block lh-1 pt-2'>Total Spent</span>
              </div>
              <div className='border border-dashed border-gray-300 w-250px rounded my-3 p-4 me-6'>
                <span className='fs-2x fw-bold text-gray-800 lh-1'>
                  {totalBalance.total_credit ? (
                    <CurrencyFormat
                      decimalScale={2}
                      value={parseFloat(totalBalance?.total_debit).toFixed(2)}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'$'}
                    />
                  ) : (
                    '$0'
                  )}
                </span>
                <span className='fs-6 fw-semibold text-danger d-block lh-1 pt-2'>
                  Total Withdrawn
                </span>
              </div>
              <div className='border border-dashed border-gray-300 w-250px rounded my-3 p-4 me-6'>
                <span className='fs-2x fw-bold text-gray-800 lh-1'>
                  <span
                    data-kt-countup='true'
                    data-kt-countup-value='1,240'
                    data-kt-countup-prefix='$'
                  >
                    {totalBalance.total_credit ? (
                      <CurrencyFormat
                        decimalScale={2}
                        value={parseFloat(totalBalance?.total_available_balance).toFixed(2)}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                      />
                    ) : (
                      '$0'
                    )}
                  </span>
                </span>
                <span className='fs-6 fw-semibold text-success d-block lh-1 pt-2'>Balance</span>
              </div>
              <div className='border border-dashed border-gray-300 w-250px rounded my-3 p-4 me-6'>
                <span className='fs-2x fw-bold text-gray-800 lh-1'>
                  <span
                    data-kt-countup='true'
                    data-kt-countup-value='6,840'
                    data-kt-countup-prefix='$'
                  >
                    {totalBalance.total_pendding ? (
                      <CurrencyFormat
                        decimalScale={2}
                        value={parseFloat(totalBalance?.total_pendding).toFixed(2)}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                      />
                    ) : (
                      '$0'
                    )}
                  </span>
                </span>
                <span className='fs-6 fw-semibold text-warning d-block lh-1 pt-2'>
                  Total Pending
                </span>
              </div>
              <div className='border border-dashed border-gray-300 w-250px rounded my-3 p-4 me-6'>
                <span className='fs-2x fw-bold text-gray-800 lh-1'>
                  <span
                    data-kt-countup='true'
                    data-kt-countup-value='1,240'
                    data-kt-countup-prefix='$'
                  >
                    {totalBalance.total_credit ? (
                      <CurrencyFormat
                        decimalScale={2}
                        value={parseFloat(totalBalance?.due_balance).toFixed(2)}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                      />
                    ) : (
                      '$0'
                    )}
                  </span>
                </span>
                <span className='fs-6 fw-semibold text-info d-block lh-1 pt-2'>Due Balance</span>
              </div>
            </div>
            <div className='d-flex'>
              {/* <button
                className='btn btn-primary px-6 flex-shrink-0 align-self-center'
                onClick={() => {
                  setShowCreateAppModal(true)
                }}
              >
                Withdraw Money
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {Statements}
